import Swiper from "swiper";
import { addToGlobalThisRet, findControls } from "@plugins";

function initSelection() {
    const selection = document.querySelector(".js-popular-brands");

    if (selection) {
        const sliderContainer = selection.querySelector(".js-popular-brands-slider");
        const controls = findControls(selection, ".js-popular-brands-controls");

        new Swiper(sliderContainer, {
            slidesPerView: 6,
            spaceBetween: 16,
            preventClicks: false,
            navigation: {
                prevEl: controls.buttonPrev,
                nextEl: controls.buttonNext,
            },
        });
    }
}
initSelection();

// Записываем в глобальный подобъект для бэка
addToGlobalThisRet(initSelection, "initSelection");
